<template>
  <div class="sub_tab">
    <ul class="sub_tab_menu">
      <template v-for="(item, i) in links">
        <li
            :key="i"
            @click="showLnb = item"
            @mouseenter="showLnb = item"
            @mouseover="showLnb = item"
            @mouseleave="showLnb = null"
            :class="[$route.path == `/introduce/${item.url}` ? 'on' : '']"
        >
          <router-link :to="`/introduce/${item.url}`">
            {{ item.name }}
          </router-link>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      links: [
        {
          name: "사업개요",
          url: "overview",
        },
        {
          name: "공유플랫폼의 필요성",
          url: "necessity",
        },
        {
          name: "운영전략",
          url: "strategy",
        },
        {
          name: "연구단구성",
          url: "member",
        },
      ]
    }
  }
};
</script>